<template>
  <BaseModal
    modal-id="file-edit"
    :is-open="isOpen"
    :save-state="isSaving ? 'saving' : 'fresh'"
    :header-text="$t('Edit file')"
    :confirm-button-text="$t('Save')"
    @save="saveFile"
    @cancel="$emit('canceled')"
  >
    <div class="m-t-10 form-group">
      <label>{{ $t('Filename') }}</label>

      <div class="input-group">
        <input v-model="form.name" class="form-control" />

        <div class="input-group-addon">.{{ file.extension }}</div>
      </div>
    </div>

    <div class="form-group">
      <label>{{ $t('Tags') }}</label>

      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <TypeSelect
        name="tags"
        tag-type="skills"
        :options-in="availableTags"
        :locale-in="language"
        :selected-in="form.tags"
        :placeholder="$t('Eg. Contracts, Terms, etc...')"
        :show-typesuggestions="false"
        :can-add-unsupported-types="true"
      />
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'

export default {
  components: { BaseModal },
  props: {
    file: {
      type: Object,
      default: () => ({}),
    },

    availableTags: {
      type: Array,
      required: true,
    },

    isSaving: {
      type: Boolean,
      required: false,
    },

    isOpen: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      form: {
        name: '',
        tags: [],
      },
      language: currentLanguageSelected,
    }
  },

  created() {
    this.form.name = this.file.name.replace(/\.[^/.]+$/, '')
    this.form.tags = this.file.tags.map((tag) => tag.name)
  },

  methods: {
    async saveFile() {
      this.$emit('save', [this.file.localId, this.form.name, this.form.tags])
      this.$emit('updated')
    },
  },
}
</script>
